import { Differentiation } from 'approot/shared/differentiation/differentiation.constants';

export function getDifferentiationDescription(
  differentiation: Differentiation,
  unitQuizDescription: string
) {
  switch (differentiation) {
    case Differentiation.GreenCircle:
      return 'The green circle represents core activities. They are central to the focus question or learning intention and include surface, deeper and transfer of learning.';
    case Differentiation.BlueSquare:
      return 'The blue square represents deeper learning activities. They take thinking to the next level and require more time, effort and sometimes research.';
    case Differentiation.BlackDiamond:
      return 'The black diamond represents challenging activities. They require extended critical and creative thinking.';
    case Differentiation.OrangeCross:
      return 'The orange cross represents support activities. These help bridge gaps in understanding of core concepts.';
    case Differentiation.SelfAssessment:
      return 'Support students to reflect on their achievements.';
    case Differentiation.AnchorMap:
      return 'An Anchor Map is a frame for students to express and share their learning across a topic, unit of work or cycle of learning.';
    case Differentiation.UnitQuiz:
      return unitQuizDescription;
  }
}
